import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Layout } from 'antd';
const { Content } = Layout;

import './styles.less';

/**
 * Used to hold the content for pages. This includes an offset for the
 * fixed header at the top of the page.
 */
export const PageContent = ( { children, className } ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'page-content',
        { [ className ]: Boolean( className ) },
    );

    return (
        <Content className={ classes }>
            { children }
        </Content>
    );
};

PageContent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
